module.exports = __webpack_public_path__ + "media/images/members/maria_carbajo_lago-0d3427dba9b0e94d79daa0b032b89db4.jpg";